(function() {
    angular
        .module("app")
        .controller("DeletePageModalController", DeletePageModalController)

    DeletePageModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "pageNumber"
    ]

    function DeletePageModalController(
        $scope,
        $uibModalInstance,
        pageNumber
    ){
        "use strict"

        $scope.pageNumber = pageNumber

        $scope.ok = function() {
            $uibModalInstance.close()
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
